
















import {Component, Prop, Vue} from 'vue-property-decorator'
import toBgClClass from '@/filters/to-bg-cl-class'
import toTextClClass from '@/filters/to-text-cl-class'

@Component
export default class KTag extends Vue {
  @Prop({default: 'gray-200'}) color: string
  @Prop({default: 'primary'}) textColor: string
  @Prop() label?: string
  @Prop({default: 'medium', type: String}) size?: string

  get sizeClass() {
    switch(this.size) {
      case 'medium':
        return ['k-pa-y-xs', 'k-text-subtitle1', 'k-tag__medium']
      case 'mini':
        return ['k-text-content', 'k-tag__sm']
      default:
        return ['k-pa-y-xs', 'k-text-subtitle1', 'k-tag__medium']
    }
  }

  get classes() {
    return [toBgClClass(this.color), toTextClClass(this.textColor), this.sizeClass]
  }
}
